import { useEffect, useState } from "react";
import Container from "@/components/Container";
import Pager, { usePager } from "@/components/Pager";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function NotesAdmin() {
  const [items, setItems] = useState([]);
  const [body, setBody] = useState("");
  const load = () => api.get("/notes").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    if (!body.trim()) return;
    await api.post("/notes", { body });
    setBody(""); toast.success("Note saved"); load();
  };
  const del = async (id) => { await api.delete(`/notes/${id}`); load(); };
  const pager = usePager(items);
  return (
    <Container className="py-8 md:py-12">
      <p className="overline">CRM</p>
      <h1 className="mt-2 text-4xl md:text-5xl font-serif text-ivory">Notes</h1>
      <form onSubmit={add} className="luxury-card p-5 mt-6">
        <textarea rows={3} className="w-full bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm" placeholder="Write a note…" value={body} onChange={e => setBody(e.target.value)} />
        <button className="btn-ruby mt-3">Save Note</button>
      </form>
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.length === 0 && <p className="luxury-card p-6 text-center text-ivory/40 text-sm md:col-span-2">No notes.</p>}
        {pager.pageItems.map(n => (
          <div key={n.id} className="luxury-card p-5">
            <p className="text-[0.65rem] uppercase tracking-[0.15em] text-gold">{new Date(n.created_at).toLocaleString()}</p>
            <p className="mt-2 text-ivory/80 whitespace-pre-line text-sm">{n.body}</p>
            <button onClick={() => del(n.id)} className="btn-outline !py-1 !px-2 !text-[0.65rem] mt-3">Delete</button>
          </div>
        ))}
      </div>
      <Pager {...pager} testid="notes-pager" />
    </Container>
  );
}
